import { Component, OnInit, Inject } from "@angular/core";
import { Endereco } from "../models/endereco.model";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";


@Component({
	selector: 'app-cep-modal-list',
	templateUrl: './cep-modal-list.component.html',
	styleUrls: ['./cep-modal-list.component.styl'],
})
export class CepModalListComponent implements OnInit {

	public adresses: Endereco[] = [];

	constructor(
		public dialogRef: MatDialogRef<CepModalListComponent>,
		@Inject(MAT_DIALOG_DATA) public data: Endereco[],
	) {
		this.adresses = data;
	}

	ngOnInit(): void {
	}

	selectCep(adress: Endereco) {
		this.dialogRef.close(adress);
	}

	close(): void {
		this.dialogRef.close();
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/collection/modal-cep/modal-list/cep-modal-list.component.ts